import { render } from "./MetaMaskConnect.vue?vue&type=template&id=154a55e3&scoped=true"
import script from "./MetaMaskConnect.vue?vue&type=script&lang=js"
export * from "./MetaMaskConnect.vue?vue&type=script&lang=js"

import "./MetaMaskConnect.vue?vue&type=style&index=0&id=154a55e3&lang=scss&scoped=true"

import exportComponent from "/opt/buildhome/repo/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-154a55e3"]])

export default __exports__